//Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { RegisterService } from '../services/RegisterService';
//Models
import { Credential } from '../models/Credential';
import { NonAisParent } from '../models/NonAisParent';

@Component({
    selector: 'user-register',
    template: require('./HolRegisterComponent.html'),
    styles: [require('./HolRegisterComponent.sass')]
})

export class HolRegisterComponent implements OnInit {
    message: string;
    selectedTab: number;
    messageType: string;
    redirectUrl: string;
    credential: Credential;
    nonAisParent: NonAisParent;
    formSubmitted: boolean = false;
    schools: any;

    constructor(
        private sessionService: SessionService,
        private userService: UserService,
        private registerService: RegisterService,
        private router: Router
    ) {
        
    }

    ngOnInit() {
        this.redirectUrl = '/booking/students';
        this.nonAisParent = new NonAisParent();
        this.credential = new Credential('', '', '');
        // Use Session Service to get session and check if user had already logged in.
        this.getSession();
        this.schools = [
            {
                name: 'Australian Internation School',
                value: 1,
            },
            {
                name: 'Others',
                value: 2,
            },
        ];
        this.schools.value = 1;
        this.selectedTab = 1;
    }

    onSubmit() {
        this.credential.role = 'parent'
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.register();
    }
    
    onSubmitNonAis() {
        this.credential = new Credential('hol-parent', '', '');
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.registerNonAis(this.nonAisParent);

    }
    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.redirect();
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    private register() {
        this.registerService.postActivationEmail(this.credential.role, this.credential.email)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "An activation email had been sent.";
                    this.formSubmitted = false;
                },
                error => {
                    this.messageType = "alert";
                    this.message = "Please input the email you provided to AIS.";
                    this.formSubmitted = false;
                }
            );
    }

    private registerNonAis(nonAisParent: NonAisParent) {
        this.registerService.postNoneAisAccount(nonAisParent)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "An activation email had been sent.";
                    this.formSubmitted = false;
                },
                error => {
                    let errorObj = JSON.parse(error['_body']);
                    this.messageType = "alert";
                    this.message = errorObj.message;
                    this.formSubmitted = false;
                }
            );
    }

    private redirect() {
        // Redirect to stored url
        this.router.navigate([this.redirectUrl]);
    }

    private activateTab(tabId: number) {
        this.selectedTab = tabId;
    }
 }


// WEBPACK FOOTER //
// ./src/common/modules/user/hol-register/HolRegisterComponent.ts